import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModeloVisualizacao = _resolveComponent("ModeloVisualizacao")!
  const _component_ModeloEdicao = _resolveComponent("ModeloEdicao")!

  return (_openBlock(), _createElementBlock("div", null, [
    (!_ctx.modelo.getEmEdicao())
      ? (_openBlock(), _createBlock(_component_ModeloVisualizacao, {
          key: 0,
          modelo: _ctx.modelo,
          ehPrimeiro: _ctx.ehPrimeiro,
          ehUltimo: _ctx.ehUltimo,
          onEditar: _ctx.editar,
          onExcluir: _ctx.excluir,
          onDescer: _ctx.descer,
          onSubir: _ctx.subir,
          onSelecionar: _ctx.selecionar
        }, null, 8, ["modelo", "ehPrimeiro", "ehUltimo", "onEditar", "onExcluir", "onDescer", "onSubir", "onSelecionar"]))
      : _createCommentVNode("", true),
    (_ctx.modelo.getEmEdicao())
      ? (_openBlock(), _createBlock(_component_ModeloEdicao, {
          key: 1,
          modelo: (_ctx.modelo as ModeloEditavel)
        }, null, 8, ["modelo"]))
      : _createCommentVNode("", true)
  ]))
}